import axios from 'axios';
import {flashMessage} from 'redux-flash';
import Config from '../../config';
import {ProcessContentFields} from '../../helpers/Helpers';

export function filter(items) {
    return (dispatch) => {
        dispatch({
            type: 'BLOCK_FILTER',
            payload: {
                data: items
            }
        });
        return Promise.resolve(items);
    }
}

export function copyBlock(values, languageCode) {
    return (dispatch) => {
        dispatch({
            type: '@@redux-form/INITIALIZE',
            meta: {
                form: 'BlockForm',
                keepDirty: undefined
            },
            payload: {
                ...values,
                languageId: languageCode
            }
        });
        dispatch(getWidgetList(languageCode));
    }
}

export function move(id, languageCode, values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/content/' + id + '/move', values,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch(single(id, languageCode));

                dispatch({
                    type: 'BLOCK_MOVE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Block moved!', {timeout: 3000, props: {type: 'success'}}));
                dispatch(getWidgetList(languageCode));

                return response;
            }
        })
    }
}

export function single(id, languageCode) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/content/' + id + '/' + languageCode,Config.getApiConfig()).then(response => {
            if (response.data) {
                const values = ProcessContentFields(response.data.contentFields);

                values.id = response.data.id;
                values.parentContentId = response.data.parentContentId;
                values.parentWorkspaceId = response.data.parentWorkspaceId;
                values.contentVisibilityId = response.data.contentVisibilityId;

                dispatch({
                    type: 'BLOCK_SINGLE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'BlockForm',
                        keepDirty: undefined
                    },
                    payload: {
                        ...values,
                        languageId: languageCode
                    }
                });

                return response;
            }
        })
    }
}

export function patch(id, languageCode, values) {
    return (dispatch) => {
        return axios.patch(Config.api.endpoint + 'api/content/' + id + '/' + languageCode + '?removeMissingFields=true', values,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch(single(id, languageCode));

                dispatch({
                    type: 'BLOCK_PATCH_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Block updated!', {timeout: 3000, props: {type: 'success'}}));
                dispatch(getWidgetList(languageCode));

                return response;
            }
        })
    }
}

export function put(id, languageCode, values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/content/' + id + '/' + languageCode + '/publish', values,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'BLOCK_PUT_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Block published!', {timeout: 3000, props: {type: 'success'}}));
                dispatch(getWidgetList(languageCode));

                return response;
            }
        })
    }
}

export function post(languageCode, values) {
    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/content/' + languageCode + '/new', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'BLOCK_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Block created!', {timeout: 3000, props: {type: 'success'}}));
                dispatch(getWidgetList(languageCode));

                return response;
            }
        })
    }
}

export function definition(contentDefinitionKey) {

    if (contentDefinitionKey){

        return (dispatch) => {
            return axios.get(Config.api.endpoint + 'api/Content/definition/' + contentDefinitionKey,Config.getApiConfig()).then(response => {
                if (response.data) {
                    dispatch({
                        type: 'BLOCK_DEFINITION_SUCCESS',
                        payload: {
                            data: response.data
                        }
                    });

                    return response;
                }
            })
        }
    } else {
    }

}

export function structure(parentWorkspaceId, skipStore = false) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/content/structure/' + parentWorkspaceId + '/block', Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'BLOCK_STRUCTURE_SUCCESS',
                    payload: {
                        data: response.data,
                        parentWorkspaceId: parentWorkspaceId,
                        skipStore: skipStore
                    }
                });

                return response;
            }
        })
    }
}

export function destroy(id) {
    return (dispatch) => {
        return axios.delete(Config.api.endpoint + 'api/content/' + id,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'BLOCK_DESTROY_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Block deleted!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function getWidgetList(language, skipStore = false) {
    return (dispatch) => {
        dispatch({
            type: 'WIDGETS_STRUCTURE_LOADING',
            payload: {
                skipStore: skipStore
            }
        });
        return axios.get(Config.api.endpoint + 'api/Widget/list/' + language, Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'WIDGETS_STRUCTURE_SUCCESS',
                    payload: {
                        data: response.data,
                        skipStore: skipStore
                    }
                });

                return response;
            }
        })
    }
}

export function sortChildren(parentWorkspaceId, values) {
    return (dispatch) => {
        return axios.patch(Config.api.endpoint + 'api/Content/sortchildren', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch(structure(parentWorkspaceId))

                return response;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/admin/store/actions/block.js